/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  combineLatest,
  MonoTypeOperatorFunction,
  Observable,
  ObservableInput,
  ObservedValueOf,
  OperatorFunction,
  ReplaySubject,
  Subject,
  Subscription,
  timer,
} from 'rxjs';
import { delay as delayOperator, filter, map, retryWhen, scan, shareReplay, take, tap } from 'rxjs/operators';
import { debugLog, isTruthy, objectify, Predicate, Project } from './ts-util';

/* eslint-disable max-len */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
// prettier-ignore
export function combineLatestExtended<O1 extends ObservableInput<any>, O2 extends ObservableInput<any>, O3 extends ObservableInput<any>, O4 extends ObservableInput<any>, O5 extends ObservableInput<any>, O6 extends ObservableInput<any>, O7 extends ObservableInput<any>>(sources: [O1, O2, O3, O4, O5, O6, O7]): Observable<[ObservedValueOf<O1>, ObservedValueOf<O2>, ObservedValueOf<O3>, ObservedValueOf<O4>, ObservedValueOf<O5>, ObservedValueOf<O6>, ObservedValueOf<O7>]>;
// prettier-ignore
export function combineLatestExtended<O1 extends ObservableInput<any>, O2 extends ObservableInput<any>, O3 extends ObservableInput<any>, O4 extends ObservableInput<any>, O5 extends ObservableInput<any>, O6 extends ObservableInput<any>, O7 extends ObservableInput<any>, O8 extends ObservableInput<any>>(sources: [O1, O2, O3, O4, O5, O6, O7, O8]): Observable<[ObservedValueOf<O1>, ObservedValueOf<O2>, ObservedValueOf<O3>, ObservedValueOf<O4>, ObservedValueOf<O5>, ObservedValueOf<O6>, ObservedValueOf<O7>, ObservedValueOf<O8>]>;
// prettier-ignore
export function combineLatestExtended<O1 extends ObservableInput<any>, O2 extends ObservableInput<any>, O3 extends ObservableInput<any>, O4 extends ObservableInput<any>, O5 extends ObservableInput<any>, O6 extends ObservableInput<any>, O7 extends ObservableInput<any>, O8 extends ObservableInput<any>, O9 extends ObservableInput<any>>(sources: [O1, O2, O3, O4, O5, O6, O7, O8, O9]): Observable<[ObservedValueOf<O1>, ObservedValueOf<O2>, ObservedValueOf<O3>, ObservedValueOf<O4>, ObservedValueOf<O5>, ObservedValueOf<O6>, ObservedValueOf<O7>, ObservedValueOf<O8>, ObservedValueOf<O9>]>;
// prettier-ignore
export function combineLatestExtended<O1 extends ObservableInput<any>, O2 extends ObservableInput<any>, O3 extends ObservableInput<any>, O4 extends ObservableInput<any>, O5 extends ObservableInput<any>, O6 extends ObservableInput<any>, O7 extends ObservableInput<any>, O8 extends ObservableInput<any>, O9 extends ObservableInput<any>, O10 extends ObservableInput<any>>(sources: [O1, O2, O3, O4, O5, O6, O7, O8, O9, O10]): Observable<[ObservedValueOf<O1>, ObservedValueOf<O2>, ObservedValueOf<O3>, ObservedValueOf<O4>, ObservedValueOf<O5>, ObservedValueOf<O6>, ObservedValueOf<O7>, ObservedValueOf<O8>, ObservedValueOf<O9>, ObservedValueOf<O10>]>;
// prettier-ignore
export function combineLatestExtended<O1 extends ObservableInput<any>, O2 extends ObservableInput<any>, O3 extends ObservableInput<any>, O4 extends ObservableInput<any>, O5 extends ObservableInput<any>, O6 extends ObservableInput<any>, O7 extends ObservableInput<any>, O8 extends ObservableInput<any>, O9 extends ObservableInput<any>, O10 extends ObservableInput<any>, O11 extends ObservableInput<any>>(sources: [O1, O2, O3, O4, O5, O6, O7, O8, O9, O10, O11]): Observable<[ObservedValueOf<O1>, ObservedValueOf<O2>, ObservedValueOf<O3>, ObservedValueOf<O4>, ObservedValueOf<O5>, ObservedValueOf<O6>, ObservedValueOf<O7>, ObservedValueOf<O8>, ObservedValueOf<O9>, ObservedValueOf<O10>, ObservedValueOf<O11>]>;
// prettier-ignore
export function combineLatestExtended<O1 extends ObservableInput<any>, O2 extends ObservableInput<any>, O3 extends ObservableInput<any>, O4 extends ObservableInput<any>, O5 extends ObservableInput<any>, O6 extends ObservableInput<any>, O7 extends ObservableInput<any>, O8 extends ObservableInput<any>, O9 extends ObservableInput<any>, O10 extends ObservableInput<any>, O11 extends ObservableInput<any>, O12 extends ObservableInput<any>>(sources: [O1, O2, O3, O4, O5, O6, O7, O8, O9, O10, O11, O12]): Observable<[ObservedValueOf<O1>, ObservedValueOf<O2>, ObservedValueOf<O3>, ObservedValueOf<O4>, ObservedValueOf<O5>, ObservedValueOf<O6>, ObservedValueOf<O7>, ObservedValueOf<O8>, ObservedValueOf<O9>, ObservedValueOf<O10>, ObservedValueOf<O11>, ObservedValueOf<O12>]>;
// prettier-ignore
export function combineLatestExtended<
  O1 extends ObservableInput<any>,
  O2 extends ObservableInput<any>,
  O3 extends ObservableInput<any>,
  O4 extends ObservableInput<any>,
  O5 extends ObservableInput<any>,
  O6 extends ObservableInput<any>,
  O7 extends ObservableInput<any>,
  O8 extends ObservableInput<any>,
  O9 extends ObservableInput<any>,
  O10 extends ObservableInput<any>,
  O11 extends ObservableInput<any>,
  O12 extends ObservableInput<any>,
  O13 extends ObservableInput<any>,
  O14 extends ObservableInput<any>
>(
  sources: [O1, O2, O3, O4, O5, O6, O7, O8, O9, O10, O11, O12, O13, O14]
): Observable<
  [
    ObservedValueOf<O1>,
    ObservedValueOf<O2>,
    ObservedValueOf<O3>,
    ObservedValueOf<O4>,
    ObservedValueOf<O5>,
    ObservedValueOf<O6>,
    ObservedValueOf<O7>,
    ObservedValueOf<O8>,
    ObservedValueOf<O9>,
    ObservedValueOf<O10>,
    ObservedValueOf<O11>,
    ObservedValueOf<O12>,
    ObservedValueOf<O13>,
    ObservedValueOf<O14>
  ]
>;
// prettier-ignore
export function combineLatestExtended<
  O1 extends ObservableInput<any>,
  O2 extends ObservableInput<any>,
  O3 extends ObservableInput<any>,
  O4 extends ObservableInput<any>,
  O5 extends ObservableInput<any>,
  O6 extends ObservableInput<any>,
  O7 extends ObservableInput<any>,
  O8 extends ObservableInput<any>,
  O9 extends ObservableInput<any>,
  O10 extends ObservableInput<any>,
  O11 extends ObservableInput<any>,
  O12 extends ObservableInput<any>,
  O13 extends ObservableInput<any>,
  O14 extends ObservableInput<any>,
  O15 extends ObservableInput<any>
>(
  sources: [O1, O2, O3, O4, O5, O6, O7, O8, O9, O10, O11, O12, O13, O14, O15]
): Observable<
  [
    ObservedValueOf<O1>,
    ObservedValueOf<O2>,
    ObservedValueOf<O3>,
    ObservedValueOf<O4>,
    ObservedValueOf<O5>,
    ObservedValueOf<O6>,
    ObservedValueOf<O7>,
    ObservedValueOf<O8>,
    ObservedValueOf<O9>,
    ObservedValueOf<O10>,
    ObservedValueOf<O11>,
    ObservedValueOf<O12>,
    ObservedValueOf<O13>,
    ObservedValueOf<O14>,
    ObservedValueOf<O15>
  ]
>;
// eslint-disable-next-line rxjs/finnish
export function combineLatestExtended<O extends ObservableInput<any>>(sources: O[]): Observable<ObservedValueOf<O>[]> {
  return combineLatest(sources);
}

export class Single<T> extends ReplaySubject<T> {
  private _value: { emitted: boolean; value: T } = { emitted: false, value: undefined };

  constructor() {
    super(1);
  }

  public next(value: T) {
    super.next(value);
    this._value = { emitted: true, value };
    this.complete();
  }

  public get value(): { emitted: boolean; value: T } {
    return this._value;
  }

  public hasEmitted(): boolean {
    return this.value.emitted;
  }

  public emitedValue(): T {
    if (!this.hasEmitted()) {
      throw Error(`Tried to read emitted value of non-emitted Single<>`);
    }

    return this.value.value;
  }
}

// https://stackoverflow.com/questions/44979131/rxjs-retry-with-delay-function
export function retryWithDelay<T>(
  delay: number,
  count = 1,
  errorRetryPreventionPredicate: (error: any) => boolean = undefined
): MonoTypeOperatorFunction<T> {
  return (input$) =>
    input$.pipe(
      retryWhen((errors$) => {
        return errors$.pipe(
          tap((error) => {
            if (errorRetryPreventionPredicate?.(error)) {
              throw error;
            }
          }),
          scan((acc, error) => ({ count: acc.count + 1, error }), {
            count: 0,
            error: undefined as any,
          }),
          map((current) => {
            if (current.count > count) {
              throw current.error;
            }
            return current;
          }),
          delayOperator(delay)
        );
      })
    );
}

// @ts-ignore
// prettier-ignore
export function rxObjectify<S1,                                      K1 extends string>                                                                                                                                                                            (K1: K1):                                                                           OperatorFunction<[S1],                                      { [T in typeof K1]: S1 }>;
// prettier-ignore
export function rxObjectify<S1, S2,                                  K1 extends string, K2 extends string>                                                                                                                                                         (K1: K1, K2: K2):                                                                   OperatorFunction<[S1, S2],                                  { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 }>;
// prettier-ignore
export function rxObjectify<S1, S2, S3,                              K1 extends string, K2 extends string, K3 extends string>                                                                                                                                      (K1: K1, K2: K2, K3: K3):                                                           OperatorFunction<[S1, S2, S3],                              { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3}>;
// prettier-ignore
export function rxObjectify<S1, S2, S3, S4,                          K1 extends string, K2 extends string, K3 extends string, K4 extends string>                                                                                                                   (K1: K1, K2: K2, K3: K3, K4: K4):                                                   OperatorFunction<[S1, S2, S3, S4],                          { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4}>;
// prettier-ignore
export function rxObjectify<S1, S2, S3, S4, S5,                      K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string>                                                                                                (K1: K1, K2: K2, K3: K3, K4: K4, K5: K5):                                           OperatorFunction<[S1, S2, S3, S4, S5],                      { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5}>;
// prettier-ignore
export function rxObjectify<S1, S2, S3, S4, S5, S6,                  K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string, K6 extends string>                                                                             (K1: K1, K2: K2, K3: K3, K4: K4, K5: K5, K6: K6):                                   OperatorFunction<[S1, S2, S3, S4, S5, S6],                  { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5} & {[T in typeof K6]: S6}>;
// prettier-ignore
export function rxObjectify<S1, S2, S3, S4, S5, S6, S7,              K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string, K6 extends string, K7 extends string>                                                          (K1: K1, K2: K2, K3: K3, K4: K4, K5: K5, K6: K6, K7: K7):                           OperatorFunction<[S1, S2, S3, S4, S5, S6, S7],              { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5} & {[T in typeof K6]: S6} & {[T in typeof K7]: S7}>;
// prettier-ignore
export function rxObjectify<S1, S2, S3, S4, S5, S6, S7, S8,          K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string, K6 extends string, K7 extends string, K8 extends string>                                       (K1: K1, K2: K2, K3: K3, K4: K4, K5: K5, K6: K6, K7: K7, K8: K8):                   OperatorFunction<[S1, S2, S3, S4, S5, S6, S7, S8],          { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5} & {[T in typeof K6]: S6} & {[T in typeof K7]: S7} & {[T in typeof K8]: S8}>;
// prettier-ignore
export function rxObjectify<S1, S2, S3, S4, S5, S6, S7, S8, S9,      K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string, K6 extends string, K7 extends string, K8 extends string, K9 extends string>                    (K1: K1, K2: K2, K3: K3, K4: K4, K5: K5, K6: K6, K7: K7, K8: K8, K9: K9):           OperatorFunction<[S1, S2, S3, S4, S5, S6, S7, S8, S9],      { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5} & {[T in typeof K6]: S6} & {[T in typeof K7]: S7} & {[T in typeof K8]: S8} & {[T in typeof K9]: S9}>;
// prettier-ignore
export function rxObjectify<S1, S2, S3, S4, S5, S6, S7, S8, S9, S10, K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string, K6 extends string, K7 extends string, K8 extends string, K9 extends string, K10 extends string>(K1: K1, K2: K2, K3: K3, K4: K4, K5: K5, K6: K6, K7: K7, K8: K8, K9: K9, K10: K10): OperatorFunction<[S1, S2, S3, S4, S5, S6, S7, S8, S9, S10], { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5} & {[T in typeof K6]: S6} & {[T in typeof K7]: S7} & {[T in typeof K8]: S8} & {[T in typeof K9]: S9} & {[T in typeof K10]: S10}>;
export function rxObjectify(...keys: string[]): OperatorFunction<readonly any[], Record<string, any>> {
  return (observable$) => {
    // @ts-ignore
    return observable$.pipe(map((result) => objectify(result, ...keys)));
  };
}

export function firstTruthy<T>(): OperatorFunction<T, T> {
  // Using take(1) instead of first() to avoid potential empty sequence errors
  return (observable$) => observable$.pipe(filter(isTruthy), take(1));
}

export function filterTruthy<T>(): OperatorFunction<T, T> {
  return (observable$) => observable$.pipe(filter(isTruthy));
}

export function tapLog<T>(message?: string): OperatorFunction<T, T> {
  // eslint-disable-next-line no-console
  return (observable$) => observable$.pipe(tap((data) => debugLog(message, data)));
}

export function toObject<S, K extends string>(K: K): OperatorFunction<S, { [T in typeof K]: S }> {
  return (observable$) =>
    observable$.pipe(
      map((result) => [result] as const),
      rxObjectify(K)
    );
}

export function createObject<Value, Key extends string>(Key: Key, value: Value): OperatorFunction<any, { [T in typeof Key]: Value }> {
  return (observable$) =>
    observable$.pipe(
      map(() => [value] as const),
      rxObjectify(Key)
    );
}

export function takeFirstMatching<T>(predicate: Predicate<T>): OperatorFunction<T, T> {
  return (observable$) => observable$.pipe(filter(predicate), take(1));
}

export function takeFirst<T>(): OperatorFunction<T, T> {
  return (observable$) => observable$.pipe(take(1));
}

export class BatchSubject<T> extends Subject<T[]> {
  private buffer: T[] = [];
  private timerSubscription: Subscription;

  constructor(private readonly batchDelay: number, private readonly bufferLimit = Infinity) {
    super();
  }

  public insert(item: T) {
    this.buffer.push(item);
    this.restartTimer();

    if (this.buffer.length >= this.bufferLimit) {
      this.emitBatch();
    }
  }

  private restartTimer() {
    this.timerSubscription?.unsubscribe();
    this.timerSubscription = timer(this.batchDelay).subscribe(() => this.emitBatch());
  }

  private emitBatch() {
    const clonedBuffer = this.buffer.slice();
    this.buffer = [];
    this.next(clonedBuffer);
  }
}

export function batch<T>(batchDelay: number, bufferLimit = Infinity): OperatorFunction<T, T[]> {
  const batchSubject$ = new BatchSubject<T>(batchDelay, bufferLimit);
  return (source$) => {
    source$.subscribe((item) => batchSubject$.insert(item));

    return batchSubject$;
  };
}

export function mapToKey<T, K extends keyof T>(key: K): OperatorFunction<T, T[K]> {
  return (source$) => source$.pipe(map((item) => item[key]));
}

export function repeatMap<T, S>(project: Project<T, S>): OperatorFunction<T, S> {
  return (source$) => source$.pipe(map(project), shareReplay({ bufferSize: 1, refCount: false }));
}
